import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBeatsbydreComponent } from './simple-icons-beatsbydre.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBeatsbydreComponent ],
    exports:      [ SimpleIconsBeatsbydreComponent ],
    bootstrap:    []
})
export class SimpleIconsBeatsbydreModule {}
